import React, { HTMLAttributes, HTMLProps } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Taxonomy as TaxonomyTerm,
} from '@uncinc/react-drupal-core';

import useClasses from '../../../hooks/useClasses';
import { ViewTaxonomyProps } from '..';

import './style.scss';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entities: ViewTaxonomyProps['entities'];
}

const ViewMilestones: React.FC<Props> = ({ entities, className }) => {
  const { t } = useTranslation();
  const { buildClass, joinClasses } = useClasses('ViewMilestones');

  if (entities.size === 0) {
    return null;
  }

  return (
    <div className={joinClasses(buildClass(), className)}>
      <div className={buildClass('title')}>
        <h2>{t('views.milestones.title')}</h2>
      </div>

      <ul className={buildClass('list')}>
        {entities.map((entity) => {
          const id = entity.getIn(['tid', 0, 'value']);
          const uuid: string = entity.getIn(['uuid', 0, 'value']);
          const langcode: string = entity.getIn(['langcode', 0, 'value']);

          return (
            <TaxonomyTerm
              key={`${uuid}:${langcode}`}
              id={id}
              entity={entity}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default ViewMilestones;
